import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f4f4'
      }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin()) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f4f4',
        padding: '20px'
      }}>
        <div style={{
          background: '#fff',
          padding: '40px',
          borderRadius: '10px',
          textAlign: 'center',
          maxWidth: '500px',
          boxShadow: '0 3px 10px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{
            fontFamily: 'STIHL-titling, sans-serif',
            fontSize: '24px',
            color: '#f37a1f',
            marginBottom: '15px'
          }}>
            Acceso Denegado
          </h2>
          <p style={{
            fontFamily: 'STIHL-text, sans-serif',
            fontSize: '16px',
            color: '#666',
            marginBottom: '25px'
          }}>
            No tienes permisos para acceder a esta sección.
          </p>
          <a 
            href="/" 
            style={{
              fontFamily: 'STIHL-medium, sans-serif',
              display: 'inline-block',
              padding: '12px 30px',
              background: '#f37a1f',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '8px',
              textTransform: 'uppercase',
              fontSize: '14px',
              letterSpacing: '0.5px',
              transition: 'background 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.background = '#000'}
            onMouseOut={(e) => e.target.style.background = '#f37a1f'}
          >
            Volver al Inicio
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;